"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.requestMediaPermissions = exports.checkAVPermissions = void 0;
const $ = require('jquery');
const cameraNotFoundMessage = "We couldn't find any microphone or camera. Make sure they are connected and try again";
const deniedPermissionsMessage = 'You have denied the necessary permissions to use Anywhere. Please go to Chrome Settings and enable them.';
// Permissions 
function checkPermission(selector, state) {
    switch (state) {
        case 'granted':
            $(selector).html('Enabled').addClass('text-green-mictap').removeClass('text-red-700');
            return true;
        case 'denied':
        case 'prompt':
            $(selector).html('Disabled').removeClass('text-green-mictap').addClass('text-red-700');
            return false;
        default:
            return false;
    }
}
function checkAccess(option, id) {
    return new Promise((resolve) => {
        navigator.permissions.query(option)
            .then((permissionStatus) => {
            const granted = checkPermission(id, permissionStatus.state);
            resolve(granted);
            permissionStatus.onchange = function () {
                checkPermission(id, this.state);
            };
        }).catch(() => {
            console.log('cant check if permission is given, bypassing check', option);
            checkPermission(id, 'granted');
            resolve(true);
        });
    });
}
// Get media permisision and returns whether the permissions are granted or not;
function checkAVPermissions(options) {
    return new Promise((resolve) => {
        let optionsCount = 0;
        let grantedPermissions = true;
        if (options.microphone) {
            optionsCount += 1;
            checkAccess({ name: 'microphone' }, '#micPermissionStatus')
                .then((granted) => {
                optionsCount -= 1;
                if (!granted)
                    grantedPermissions = false;
                if (optionsCount === 0)
                    resolve(grantedPermissions);
            });
        }
        if (options.camera) {
            optionsCount += 1;
            checkAccess({ name: 'camera' }, '#videoPermissionStatus')
                .then((granted) => {
                optionsCount -= 1;
                if (!granted)
                    grantedPermissions = false;
                if (optionsCount === 0)
                    resolve(grantedPermissions);
            });
        }
        if (options.midi) {
            optionsCount += 1;
            checkAccess({ name: 'midi', sysex: true }, '#midiPermissionStatus')
                .then((granted) => {
                optionsCount -= 1;
                if (!granted)
                    grantedPermissions = false;
                if (optionsCount === 0)
                    resolve(grantedPermissions);
            });
        }
    });
}
exports.checkAVPermissions = checkAVPermissions;
function requestMediaPermissions(constraints, midi = false) {
    let midiAccess = false;
    let mediaDevicesAccess = false;
    return new Promise((resolve, reject) => {
        try {
            navigator.mediaDevices.getUserMedia(constraints)
                .then((stream) => {
                if (midiAccess == midi)
                    resolve(stream);
                mediaDevicesAccess = true;
            })
                .catch((error) => {
                if (error.name === 'NotAllowedError') {
                    alert(deniedPermissionsMessage);
                }
                else if (error.name === 'NotFoundError') {
                    alert(cameraNotFoundMessage);
                }
                else {
                    console.error(error.name, error);
                }
                reject(error);
            });
        }
        catch (error) {
            console.error(error);
        }
        if (midi) {
            navigator.requestMIDIAccess({ sysex: true, software: true })
                .then(() => {
                midiAccess = true;
                if (mediaDevicesAccess)
                    resolve(null);
            })
                .catch((error) => {
                if (error.name === 'SecurityError') {
                    reject(error);
                }
                else {
                    console.error(error.name);
                }
            });
        }
    });
}
exports.requestMediaPermissions = requestMediaPermissions;
